var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list"},_vm._l((_vm.links),function(ref,index){
var href = ref.href;
var isPremiumOnly = ref.isPremiumOnly;
var title = ref.title;
var iconName = ref.iconName;
return _c('li',{key:index,staticClass:"list__item item",class:[("list__item--" + iconName)]},[_c('page-link-button',{staticClass:"item__button",attrs:{"href":href,"title":title,"is-premium-only":isPremiumOnly,"is-free-member":_vm.isFreeMember,"icon-name":iconName,"is-justify-start":true}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }